
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/businesscopymachines/contact-us",
      function () {
        return require("private-next-pages/businesscopymachines/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/businesscopymachines/contact-us"])
      });
    }
  